export default __webpack_public_path__ + "static/media/da_DK.dd85e682.svg";